import { FC, ReactNode, RefObject, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface EmptyMessagePortalProps {
  children: ReactNode;
  containerRef: RefObject<HTMLElement | null>;
  targetSelector: string;
}

const EmptyMessagePortal: FC<EmptyMessagePortalProps> = ({
  children,
  containerRef,
  targetSelector,
}) => {
  const [targetEl, setTargetEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const el = container.querySelector(targetSelector) as HTMLElement | null;
    setTargetEl(el);
  }, [containerRef, targetSelector]);

  return (
    <>
      <div className="empty-message-placeholder" aria-hidden />
      {typeof document !== 'undefined' &&
        targetEl &&
        createPortal(children, targetEl)}
    </>
  );
};

export default EmptyMessagePortal;
